import React from 'react';

import ManagedFormGroup from 'components/form/managed_input/form_group';

import type { Role } from 'bundles/backoffice/contacts/types';

interface Props {
  role: Role | null;
  roleOptions?: Role[];
  onChange: (role: Role) => void;
}

export function ContactRoleInput({ role, roleOptions, onChange }: Props) {
  // A single option is auto-selected by the caller, so don't render a single option
  if (!roleOptions || roleOptions.length < 2) {
    return null;
  }

  return (
    <ManagedFormGroup
      label="Role"
      name="role"
      options={roleOptions}
      placeholder="Choose from the dropdown"
      required
      type="combobox"
      value={role}
      onValueChange={onChange}
    />
  );
}
